export default __webpack_public_path__ + "static/media/wireframes.4f4b4ce9.png";